export const initAdmin = () => {
  console.log('[admin] init');
  const form = document.getElementById('admin-form') as HTMLFormElement | null;
  form?.addEventListener('submit', (e) => {
    e.preventDefault();
    alert('Admin OK');
  });
};